import React, { useEffect, useState } from "react";
import darkLoader from "../assests/bg-black-loader.mp4";
import lightLoader from "../assests/loader.mp4";

interface VideoLoaderProps {
  size?: "small" | "medium";
}

export default function VideoLoader({ size = "medium" }: VideoLoaderProps) {
  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains("theme-dark")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("theme-dark"));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const dimension = size === "small" ? 48 : 120;
  return (
    <video
      key={isDark ? "dark" : "light"}
      src={isDark ? darkLoader : lightLoader}
      autoPlay
      loop
      muted
      playsInline
      width={dimension}
      height={dimension}
      style={{ display: "block" }}
    />
  );
}
